<template>
    <div
        class="h-full v-spa-layout-page"
        :class="{'flex flex-col': ! loading}"
        @mouseover="$emit('page-mouseover')"
        @mouseleave="$emit('page-mouseleave')"
    >
        <template v-if="loading">
            <div class="relative py-12" v-if="loading"><v-spa-loader></v-spa-loader></div>
        </template>
        
        <template v-else>
            <div
                class="border-b border-gray-200"
                @mouseover="$emit('header-mouseover')"
                @mouseleave="$emit('header-mouseleave')"
            >
                <div :class="fullTitleContainerClassName">
                    <div class="w-full flex items-center justify-between pt-2 min-h-[100px]">
                        <div class="flex-grow">

                            <!-- SLOT: TITLE -->
                            <router-link v-if="backLink" class="text-sm text-blue-600 hover:text-blue-500" :to="backLink">
                                <i class="mr-1 text-xs far fa-arrow-left "></i>
                                {{ backLinkText }}
                            </router-link>
                            
                            <h1 class="text-lg font-normal text-gray-800 v-spa-layout-title md:text-xl" :class="titleClass">
                                <slot name="title"></slot>
                            </h1>
                        </div>

                        <!-- SLOT: BUTTON ON THE RIGHT OF THE TITLE-->
                        <div class="flex items-center">
                            <slot name="title-button"></slot>

                            <!-- Used if you want to put a form submit button in the header -->
                            <portal-target name="page-title-button"></portal-target>
                        </div>
                    </div>

                    <!-- SLOT: TABS AT THE BOTTOM OF TITLE -->
                    <div :class="$spa.css.layout.page_tabs.container">
                        <slot name="tabs">
                            <template v-if="tabs && tabs.length > 0">
                                <v-spa-layout-page-tab 
                                    v-for="tab in tabs"
                                    :key="tab.name"
                                    :tab="tab"
                                ></v-spa-layout-page-tab>
                            </template>
                            <template v-else>
                                <!-- TODO: Find a better solution to fix the difference of height when no tabs are provided -->
                                <!-- Empty space to prevent a differnce of height when no tabs is provided -->
                                <div class="w-full h-[17px]"></div>
                            </template>
                        </slot>
                    </div>
                </div>
            </div>

            <!-- SLOT: CONTENT OF THE PAGE -->
            <div
                class="flex-1 w-full"
                :class="fullContentClassName"
                @mouseover="$emit('content-mouseover')"
                @mouseleave="$emit('content-mouseleave')"
            >
                <slot name="content"></slot>
            </div>

            <slot name="footer"></slot>
        </template>
    </div>

</template>

<script>
export default {
    name: "Page",

    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        backLink: {
            type: Object,
            required: false
        },
        backLinkText: {
            type: String,
            default() {
                return this.$t('misc.back_button')
            }
        },
        tabs: {
            type: Array,
            required: false
        },
        titleContainerClassName: {
            type: String,
            default: '',
            required: false
        },
        titleClass: {
            type: String,
            default: '',
            required: false
        },
        titlePadding: {
            type: Boolean,
            default: true
        },
        contentPadding: {
            type: Boolean,
            default: true
        },
        contentPaddingBottom: {
            type: Boolean,
            default: true
        },
        useContainer: {
            type: Boolean,
            default: true
        },
        contentClassName: {
            type: String,
            required: false,
            default: ''
        },
        containerClassName: {
            type: String,
            default: 'max-w-[1800px] mx-auto',
        }
    },
    
    computed: {
        fullTitleContainerClassName()
        {
            let className = {
                'px-6 lg:px-12': this.titlePadding,
            };
            className[this.containerClassName] = this.useContainer;

            return [
                className,
                this.titleContainerClassName
            ]
        },
        fullContentClassName()
        {
            let className = {
                'px-6 pt-6 lg:pt-12 lg:px-12': this.contentPadding,
                'pb-6 lg:pb-12': this.contentPadding && this.contentPaddingBottom,
            };

            className[this.containerClassName] = this.useContainer;

            return [
                className,
                this.contentClassName
            ]
        }
    }
}
</script>